import { Locale } from "../Locale.js";

export const companyValuesId = {
	[Locale.cs]: "nase-hodnoty",
	[Locale.en]: "our-values",
	[Locale.sk]: "nase-hodnoty",
};
